/**
 * Unpublished mock: keep the HubSpot (or similar) chat FAB off the
 * primary / sticky ATC on mobile PDPs. CSS `bottom` alone often loses to
 * the widget's late inline `!important`; rewrite after inject.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 768.98px)').matches) return;
  if (!document.body || document.body.getAttribute('data-page-type') !== 'product') return;

  var SELECTORS = [
    '#hubspot-messages-iframe-container',
    '#hs-web-interactives-floating-container',
    '#hs-web-interactives-top-anchor',
    '#gorgias-chat-container',
    '#chat-button',
    'iframe#launcher'
  ];

  function clearance() {
    var raw = window.getComputedStyle(document.body).getPropertyValue('--bd-chat-clearance').trim();
    return raw || '110px';
  }

  function apply() {
    var value = clearance();
    for (var i = 0; i < SELECTORS.length; i++) {
      var el = document.querySelector(SELECTORS[i]);
      if (el) el.style.setProperty('bottom', value, 'important');
    }
  }

  apply();
  if (window.MutationObserver) {
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }
  // HubSpot is deferred until first interaction or 5s — re-apply a few times.
  [1000, 3000, 6000, 10000].forEach(function (ms) {
    setTimeout(apply, ms);
  });
})();
